import { useEffect,useState } from 'react';
import flatpickr from 'flatpickr';
import Header from '../components/Header';
import FailuresPreventedGraph from '../components/FailuresPreventedGraph';
import MaintainenceCostSavedGraph from '../components/MaintainenceCostSavedGraph';
import UnplannedDownTimeAvoidedGraph from '../components/UnplannedDownTimeAvoidedGraph';
import WeeklyDowntimeGraph from '../components/WeeklyDowntimeGraph';
import AverageMaintenanceCostGraph from '../components/AverageMaintenanceCostGraph';
import StatusStackedBarGraph from '../components/StatusStackedBarGraph';
import VehicleAgeGraph from '../components/VehicleAgeGraph';
import TopFailuresGraph from '../components/TopFailuresGraph';
import TruckHealthOverview from '../components/TruckHealthOverview';
import DatePickerInput from '../components/DatePickerInput';
import '../styles/styles.css';

const Dashboard = () => {
  //const [selectedDate, setSelectedDate] = useState(""); // state for selected date
  // const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

  const formatDateToDMY = (date) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Intl.DateTimeFormat('en-GB', options).format(date); // "04 Apr 2025"
  };
  const [selectedDate, setSelectedDate] = useState(formatDateToDMY(new Date()));
  
  //const [selectedDate, setSelectedDate] = useState(new Date());
  //const [selectedDate, setSelectedDate] = useState(new Date());

  // useEffect(() => {
  //   setTimeout(() => {
  //     flatpickr('#datePicker', { dateFormat: 'Y-m-d' });
  //   }, 0);
  // }, []);
  // useEffect(() => {
  //   setTimeout(() => {
  //     flatpickr("#datePicker", {
  //       defaultDate: new Date(),
  //       dateFormat: "d M Y",
  //       onChange: (selectedDates, dateStr) => {
  //         setSelectedDate(dateStr); // update state when a date is selected
  //       },
  //     });
  //   }, 0);
  // }, []);

  return (
    <div className="min-h-screen body_bg_color">
      <Header />

      <main className="max-w-7xl mx-auto px-1 py-6">
        {/* Top Section: Header & Date Picker */}


          <DatePickerInput
            headerText='Fleet Statistics'
            initialDate={selectedDate}
            onDateChange={(date) => setSelectedDate(date)}
          />


        {/* Recommendations & Metrics */}
        <section>
          <div className="flex flex-col md:flex-row gap-6">
            {/* Recommendations Panel (fixed 492px) */}
            <div className="w-full md:w-[492px]">
              <div className="bg-white p-4 rounded shadow">
                <h2 className="text-xl font-semibold mb-4 block_head">Recommendations by AI</h2>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ai_text">
                  <li>
                    12 Vehicles at Risk &mdash; Prioritize maintenance to prevent downtime
                  </li>
                  <li>
                    3 Common Failures Identified &mdash; Address Slide Loader Actuator, Hydraulic Cylinders, Control Sensors
                  </li>
                  {/*
                  <li>
                    Preventive maintenance has prevented 15 unexpected failures in the last 6 months, saving $12,500
                  </li>
                  */}
                  <li>
                    Preventive maintenance has prevented 15 unexpected failures.
                  </li>
                </ul>
              </div>
            </div>

            {/* Metrics Panel (remaining space) */}
            <div className="flex-1">
              <div className="flex flex-col lg:flex-row gap-2">
                <div className="flex-1 min-w-[0]">
                  <FailuresPreventedGraph selectedDate={selectedDate} />
                </div>
                <div className="flex-1 min-w-[0]">
                  <MaintainenceCostSavedGraph selectedDate={selectedDate} />
                </div>
                <div className="flex-1 min-w-[0]">
                  <UnplannedDownTimeAvoidedGraph selectedDate={selectedDate} />
                </div>
              </div>
            </div>
          </div>
        </section>




        {/* Data Charts */}
        <section className="flex flex-col md:flex-row gap-6 mt-6">
          <div className="w-full md:w-[492px]">
            <div className="bg-white p-4 rounded shadow mb-6 overflow-auto">
              <h3 className="text-lg font-semibold mb-2 block_head">Vehicles in the Fleet</h3>
              <div className="mt-4 w-full">
                <StatusStackedBarGraph selectedDate={selectedDate} />
              </div>
            </div>
            <div className="bg-white p-4 rounded shadow mb-6 overflow-auto">
              <h3 className="text-lg font-semibold mb-2 block_head">Average Vehicle Age</h3>
              <div className="mt-4 w-full">
                <VehicleAgeGraph selectedDate={selectedDate} />
              </div>  
            </div>
          </div>
          <div className="flex flex-col justify-start flex-1">
            {/*
              <div className="bg-white p-4 rounded shadow mb-6">
                <h3 className="text-lg font-semibold mb-2">Percentage Downtime Next Week</h3>
                <p className="text-3xl font-bold text-blue-600">11%</p>
                <WeeklyDowntimeGraph />
              </div>


              <div className="bg-white p-4 rounded shadow mb-6">
                <h3 className="text-lg font-semibold mb-2">Average Maintenance Cost</h3>
                <p className="text-2xl font-bold mb-4">$3,700</p>
                <AverageMaintenanceCostGraph />
              </div>
            */}
            <div className="flex-1 mb-6">
              <WeeklyDowntimeGraph selectedDate={selectedDate}/>
            </div>
            <div className="flex-1 mb-6">
              <TopFailuresGraph selectedDate={selectedDate}/>
            </div>
          </div>
        </section>
        <section>
          <TruckHealthOverview selectedDate={selectedDate}/>
        </section>
        
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-4 text-center text-gray-600">
          &copy; 2025 Tensor Planet. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Dashboard;
